
export default {
  props: {
    material: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      playbackRate: 2
    };
  },

  watch: {
    playbackRate: function playbackRate(val) {
      this.setVideoRate();
    }
  },
  computed: {
    // 高风险广告主或高风险标签产品, 禁止切换
    radioDisabled: function radioDisabled() {
      return this.material.adv_warning || this.material.tag_warning;
    }
  },
  mounted: function mounted() {
    if (document.querySelector('video')) {
      // 高风险广告主或高风险标签产品，视频素材预览强制1倍速
      this.playbackRate = this.material.adv_warning || this.material.tag_warning ? 1 : 2;
      this.setVideoRate();
    }
  },

  methods: {
    setVideoRate: function setVideoRate() {
      document.querySelector('video').playbackRate = this.playbackRate;
    }
  }
};